import { HttpRequest } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private requests = signal(new Set<HttpRequest<unknown>>());

  public isLoading = signal(false);

  constructor() { }

  public add(request: HttpRequest<unknown>): void {
    this.requests().add(request);
    this.isLoading.set(this.requests().size > 0)
  }

  public delete(request: HttpRequest<unknown>): void {
    this.requests().delete(request);
    this.isLoading.set(this.requests().size > 0)
  }
}